import { BackButton, MainButton, View } from '@ds'
import { Dialog } from '@shared'
import {
  DialogOverlayData,
  PLAYER_AVATAR_TYPE,
  QuestId,
  useMainQuest,
  useMainQuestActions,
  useOverlayActions,
} from '@store'

import styles from './DialogOverlay.module.scss'

const AUDIO_SRC = {
  [QuestId.Eye]: '/sounds/narrator/Prologue_Aeron_full_Good_06.mp3',
  [QuestId.Flowers]: '/sounds/narrator/Prologue_Aeron_full_Good_09.mp3',
}

export const DialogOverlay = ({ slug }: DialogOverlayData['payload']) => {
  const questDialog = useMainQuest.store.questDialog()
  const isDialogComplete = useMainQuest.store.isDialogComplete()
  const { hideOverlay } = useOverlayActions()
  const { resetQuestDialog } = useMainQuestActions()


  const handleClose = () => {
    resetQuestDialog()
    hideOverlay()
  }

  return (
    <View fadeIn className={styles.view}>
      <BackButton onClick={handleClose} />
      <MainButton hidden />
      <Dialog
        questDialog={questDialog}
        playerAvatar={PLAYER_AVATAR_TYPE}
        audioSrc={AUDIO_SRC[slug as keyof typeof AUDIO_SRC]}
        questId={slug as QuestId}
        onClose={handleClose}
      />
    </View>
  )
}
